export const languageItems = [
  {
    id: 2,
    key: 'en',
    code: 'en-US',
    title: 'English',
    shortTitle: 'En',
    value: 'DEF917491852CF99',
  },
  {
    id: 1,
    key: 'tr',
    code: 'tr-TR',
    title: 'Türkçe',
    shortTitle: 'Tr',
    value: '825FD80875ADDE0B',
  },
  {
    id: 69,
    key: 'es',
    code: 'es-ES',
    title: 'Español',
    shortTitle: 'Es',
    value: 'F3ACA5D2B90F4B81',
  },
  {
    id: 25,
    key: 'fr',
    code: 'fr-FR',
    title: 'Français',
    shortTitle: 'Fr',
    value: '5962CAAE6B0BCFC2',
  },
  {
    id: 27,
    key: 'de',
    code: 'de-DE',
    title: 'Deutsch',
    shortTitle: 'De',
    value: 'F5234C0737BFE469',
  },
];
